export const SimNumberMask: (string | RegExp)[] = [/\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, /\d/, " ", /\d/];
